import { render, staticRenderFns } from "./bloodsugar.vue?vue&type=template&id=c803300a"
import script from "./bloodsugar.vue?vue&type=script&lang=js"
export * from "./bloodsugar.vue?vue&type=script&lang=js"
import style0 from "./bloodsugar.vue?vue&type=style&index=0&id=c803300a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports